export const routes = [
  {
    path: '/no-access',
    name: '/no-access',
    component: () => import('/builds/blum/project-tools-vue/htdocs/src/pages/no-access.vue'),
    /* no children */
  },
  {
    path: '/project-cost',
    name: '/project-cost',
    component: () => import('/builds/blum/project-tools-vue/htdocs/src/pages/project-cost.vue'),
    /* no children */
  },
  {
    path: '/resource-planning',
    name: '/resource-planning',
    component: () => import('/builds/blum/project-tools-vue/htdocs/src/pages/resource-planning.vue'),
    /* no children */
  },
  {
    path: '/task-item-package',
    /* internal name: '/task-item-package' */
    /* no component */
    children: [
      {
        path: '',
        name: '/task-item-package/',
        component: () => import('/builds/blum/project-tools-vue/htdocs/src/pages/task-item-package/index.vue'),
        /* no children */
      }
    ],
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

